import { connect as reactReduxConnect } from 'react-redux';
import RFIsContext from './RFIsContext';

const connect = (mapStateToProps, mapDispatchToProps, mergeProps, options = {}) => {
  return reactReduxConnect(mapStateToProps, mapDispatchToProps, mergeProps, { ...options, context: RFIsContext });
};

export { connect };
